import PropTypes from 'prop-types';

export const HotkeyPropType = PropTypes.shape({
  displayHotkeyStrings: PropTypes.arrayOf(PropTypes.string),
  barcode: PropTypes.string,
  hotkey: PropTypes.arrayOf(
    PropTypes.oneOfType([
      PropTypes.shape({
        hasCtrlEquivalent: PropTypes.bool,
        hasModifier: PropTypes.bool,
        key: PropTypes.string,
      }),
      PropTypes.string,
    ]),
  ),
  handler: PropTypes.func,
  name: PropTypes.string,
  legacyCategory: PropTypes.oneOf(['general', 'navigation', 'printing', 'shipping']),
  doNotTrack: PropTypes.bool,
  matches: PropTypes.func,
  isGlobal: PropTypes.bool,
  doNotClearBufferOnCompleteMatch: PropTypes.bool,
  partialMatch: PropTypes.arrayOf(PropTypes.string),
  isCustomPreset: PropTypes.bool,
  presetName: PropTypes.string,
});
